'use strict';
/**
 * @author Maxim Seredkin
 */
export default ['$resource', function($resource) {
    return $resource('api/taxes/:taxId', null, {
        getAll: {method: 'GET'},
        get: {method: 'GET'},
        create: {url: 'api/taxes/:taxId/create', method: 'POST'},
        update: {url: 'api/taxes/:taxId/update', method: 'POST'},
        remove: {url: 'api/taxes/:taxId/delete-logically', method: 'POST'},
        enable: {url: 'api/taxes/:taxId/recovery', method: 'POST'},
        delete: {url: 'api/taxes/:taxId/delete', method: 'POST'},
        getDefault: {url: 'api/taxes/default', method: 'GET'},
        setDefault: {url: 'api/taxes/:taxId/default', method: 'POST'},
        isUniqueName: {url: 'api/taxes/unique/name/:name', method: 'GET'},
        exists: {url: 'api/taxes/exists', method: 'GET'},
    });
}];
